import { useEffect } from "react";

export interface KeyboardShortcut {
    key: string;
    ctrlKey?: boolean;
    shiftKey?: boolean;
    altKey?: boolean;
    metaKey?: boolean;
    action: (event: KeyboardEvent) => void;
    preventDefault?: boolean;
}

export const useKeyboardShortcuts = (shortcuts: KeyboardShortcut[]) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            for (const shortcut of shortcuts) {
                const {
                    key,
                    ctrlKey = false,
                    shiftKey = false,
                    altKey = false,
                    metaKey = false,
                    action,
                    preventDefault = true
                } = shortcut;

                const matchesModifiers =
                    (ctrlKey === false || event.ctrlKey === ctrlKey) &&
                    (shiftKey === false || event.shiftKey === shiftKey) &&
                    (altKey === false || event.altKey === altKey) &&
                    (metaKey === false || event.metaKey === metaKey);

                if (event.key === key && matchesModifiers) {
                    if (preventDefault) {
                        event.preventDefault();
                    }
                    action(event);
                    break;
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [shortcuts]);
};